<template>
  <footer class="footer-modern">
    <div class="container-fluid">
      <div class="footer-content">
        <!-- About Section -->
        <div class="footer-section">
          <h4 class="footer-title">APIE MUS</h4>
          <p class="footer-text">
            Esame rinkoje jau ilga laikotarpį. Mūsų klientų pasitikėjimas iki šiol yra pirminis prioritetas.
            Atsižveldami į Jūsų lūkesčius siekiame jog gedimai būtų pamirštas galvos skausmas.
          </p>
        </div>

        <!-- Services Section -->
        <div class="footer-section">
          <h4 class="footer-title">PASLAUGOS</h4>
          <ul class="footer-list">
            <li v-for="(service, index) in services" :key="index">
              <ChevronRightIcon class="footer-icon" />{{ service }}
            </li>
          </ul>
        </div>

        <!-- Contact Section -->
        <div class="footer-section">
          <h4 class="footer-title">SUSISIEKITE</h4>
          <ul class="footer-contact">
            <li>
              <InboxIcon class="footer-contact-icon" />
              <a href="mailto:info@arunvilkasa.lt">info@arunvilkasa.lt</a>
            </li>
            <li>
              <PhoneIcon class="footer-contact-icon" />
              <a href="tel:+37061692311">+370 6 16 92 311</a>
            </li>
            <li>
              <MapIcon class="footer-contact-icon" />
              <span>Stoties g. 12, Jieznas</span>
            </li>
          </ul>
        </div>

        <!-- Hours Section -->
        <div class="footer-section">
          <h4 class="footer-title">DARBO VALANDOS</h4>
          <div class="footer-hours">
            <div class="hours-item">
              <span class="hours-day">Pirmadienis - Penktadienis</span>
              <span class="hours-time">08:00 - 17:00</span>
            </div>
            <div class="hours-item">
              <span class="hours-day">Šeštadienis - Sekmadienis</span>
              <span class="hours-time">Uždaryta</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Links -->
      <div class="footer-links">
        <a href="#" @click.prevent="openPrivacy">Privatumo politika</a>
        <span class="footer-separator">·</span>
        <a href="#" @click.prevent="openCookiesPolicy">Slapukų politika</a>
        <span class="footer-separator">·</span>
        <a href="#" @click.prevent="openCookies">Slapukų nustatymai</a>
      </div>

      <!-- Copyright -->
      <div class="footer-copyright">
        <p class="copyright-text">{{ year }} © Visos teisės saugomos</p>
      </div>
    </div>
  </footer>
</template>

<script>
import {ChevronRightIcon, InboxIcon, MapIcon} from '@heroicons/vue/outline'
import {PhoneIcon} from '@heroicons/vue/solid';
import { openCookieSettings } from '@/utils/consent'

export default {
  name: "Footer",
  components: {
    ChevronRightIcon,
    InboxIcon,
    PhoneIcon,
    MapIcon,
  },
  props: {
    type: {
      type: String,
      default: 'auto', // 'auto' or 'digging'
      validator: (value) => ['auto', 'digging'].includes(value)
    }
  },
  computed: {
    services() {
      if (this.type === 'auto') {
        return [
          'Tepalų keitimas',
          'Išmetimo vamzdžiai',
          'Stabdžių remontas',
          'Padangų montavimo',
          'Oro kondicionieriai',
          'Vairas ir pakaba',
          'Variklių taisymas bei keitimas'
        ]
      } else {
        return [
          'Žemės kasimas',
          'Žemės lyginimas',
          'Tvenkinių kasimas',
          'Sklypo formavimas',
          'Griovimo darbai',
          'Technikos nuoma'
        ]
      }
    }
  },
  setup() {
    const year = new Date().getFullYear();
    return {
      year
    }
  },
  methods: {
    openPrivacy() {
      window.dispatchEvent(new CustomEvent('arunvilkasa:open-privacy'))
    },
    openCookiesPolicy() {
      window.dispatchEvent(new CustomEvent('arunvilkasa:open-cookies'))
    },
    openCookies() {
      openCookieSettings()
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;1,300&display=swap');

.footer-modern {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  padding: 60px 20px 30px;
  position: relative;
  overflow: hidden;
  border-top: 4px solid #dc3545;
}

.footer-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse"><path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern></defs><rect width="100%" height="100%" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
  z-index: 0;
}

.footer-modern > * {
  position: relative;
  z-index: 1;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #dc3545;
  display: inline-block;
}

.footer-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.3s ease, transform 0.3s ease;
}

.footer-list li:hover {
  color: #ffffff;
  transform: translateX(5px);
}

.footer-icon {
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
}

.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-contact li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
}

.footer-contact-icon {
  width: 20px;
  height: 20px;
  color: rgba(255, 255, 255, 0.8);
  flex-shrink: 0;
}

.footer-contact a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-contact a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer-contact span {
  color: rgba(255, 255, 255, 0.85);
}

.footer-hours {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.hours-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.hours-item:last-child {
  border-bottom: none;
}

.hours-day {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
}

.hours-time {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.footer-links {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  padding: 0 8px;
}

.footer-links a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer-separator {
  color: rgba(255, 255, 255, 0.5);
  padding: 0 4px;
}

.footer-copyright {
  text-align: center;
  padding-top: 25px;
  margin-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.copyright-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .footer-modern {
    padding: 40px 15px 20px;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-title {
    font-size: 1.1rem;
  }
  
  .footer-copyright {
    padding-top: 20px;
    margin-top: 20px;
  }
}
</style>